export const APOLLO_MUTATION_RESULT = 'APOLLO_MUTATION_RESULT'
export const APOLLO_QUERY_RESULT = 'APOLLO_QUERY_RESULT'



// WEBPACK FOOTER //
// ./src/redux/apollo/actionTypes.js